module.exports = __webpack_public_path__ + "assets/gongzuohuibao.a1149837.svg";